import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { Menu, X } from 'lucide-react'; // You can replace with any icon lib
import { useNavigate } from "react-router-dom";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);
  const navigate = useNavigate();
  
  return (
    <header className="site-header">
      <div className="container header-container">
        <div className="site-logo">
          <Link to="/" className="logo-link">
            <img 
              src="/images/logo/buildnear-logo-3d-512.png" 
              alt="BuildNear Logo" 
              className="logo-img"
            />
            <div className="logo-text">
              <h2>Build Near</h2>
              <p>Building Connections, Near You</p>
            </div>
          </Link>
        </div>

        {/* Hamburger icon */}
        <div className="hamburger" onClick={toggleMenu}>
          {isOpen ? <X color="white" size={28} /> : <Menu color="white" size={28} />}
        </div>

        {/* Navigation */}
        <nav className={`center-nav ${isOpen ? 'open' : ''}`}>
          <ul className="nav-links">
            <li><Link to="/" onClick={closeMenu}>Home</Link></li>
            <li><Link to="/find-dealer" onClick={closeMenu}>Dealers</Link></li>
            <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
          </ul>
        </nav>

        <div className="right-cta">
          <Link to= "/dealer/register" className="btn-dealer">
            Register as Dealer
          </Link>

          <Link to= "/dealer/login" className="btn-dealer" >
            Dealer Login
          </Link>
        </div>
      </div>
    </header>
  );
}
